import range from 'lodash/range';
import React, {ReactNode} from 'react';
import '../../styles/table.scss';

type Props = {
    className?: string;
    children?: ReactNode;
    thead?: ReactNode;
} & ({
    colgroup?: ReactNode;
} | {
    cols?: number;
});

const Table = ({
    className = '',
    children: tbody,
    thead,
    ...props
}: Props) => <table className={`table forms-table ${className}`}>
    {props.hasOwnProperty('colgroup') ?
        <colgroup>{(props as {colgroup: ReactNode}).colgroup}</colgroup> :
    props.hasOwnProperty('cols') ?
        <colgroup>
            {range((props as {cols: number}).cols).map((i) =>
                <col key={i} />
            )}
        </colgroup> :
    null}
    {thead && <thead>{thead}</thead>}
    {tbody && <tbody>{tbody}</tbody>}
</table>;

export default Table;
